/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import CKEditor from 'ckeditor4-react'
// import { CKEditor } from '@ckeditor/ckeditor5-react'
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
// import '@ckeditor/ckeditor5-build-classic/build/translations/ar'
import {
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  Switch,
  TextField
} from '@material-ui/core'
import { useStyles } from './Styles'
import { useFormik } from 'formik'
import { pageFormValidation } from '../../../../utils/validationSchema'
import { FormLoader } from '../../../Loader/FormLoader'
import { useHistory } from 'react-router-dom'
import { NamedRoutes } from '../../../../routes'
import { LanguageConsumer } from '../../../../LanguageContext'

const PageForm = ({ currentDate, adminSectionType, onSubmit }) => {
  const classes = useStyles()
  const intl = useIntl()
  const history = useHistory()
  const PageForm = useFormik({
    initialValues: {
      title: currentDate.title || '',
      slug: currentDate.slug || '',
      content: currentDate.content || '',
      published: !!Object.keys(currentDate).length ? currentDate.published : true
    },
    validateOnBlur: false,
    validateOnChange: true,
    validationSchema: pageFormValidation,
    onSubmit: ((values, actions) => {
      onSubmit(values, actions)
    })
  })
  const [publishedValue, setPublishedValue] = React.useState(PageForm.values.published)
  const handlePublishedChange = (event) => {
    setPublishedValue(!JSON.parse(event.target.value))
    PageForm.setFieldValue('published', !JSON.parse(event.target.value))
  }
  let errorClass = PageForm.errors.content ? ' Mui-error' : ''
  return (
    <form onSubmit={PageForm.handleSubmit} noValidate autoComplete="off"
          className={classes.formWrapper}>

      <div className={classes.BasicInfoRow}>
        <InputLabel id="Page.Title"> {<FormattedMessage id='Fields.label.PageTitle'/>} </InputLabel>
        <FormControl variant="outlined">
          <TextField
            placeholder={intl.formatMessage({ id: 'Page.placeholder.PageTitle' })}
            id="Page.Title"
            type={'text'}
            margin="dense"
            variant="outlined"
            name='title'
            value={PageForm.values.title}
            onChange={PageForm.handleChange}
            onBlur={PageForm.handleBlur}
            helperText={PageForm.errors.title && PageForm.touched.title && PageForm.errors.title}
            error={PageForm.errors.title && PageForm.touched.title !== undefined}
          />
        </FormControl>
      </div>

      <div className={classes.BasicInfoRow}>
        <InputLabel id="Page.Slug"> {<FormattedMessage id='Fields.label.PageSlug'/>} </InputLabel>
        <FormControl variant="outlined">
          <TextField
            placeholder={intl.formatMessage({ id: 'Page.placeholder.PageSlug' })}
            id="Page.Slug"
            type={'text'}
            margin="dense"
            variant="outlined"
            name='slug'
            value={PageForm.values.slug}
            onChange={PageForm.handleChange}
            onBlur={PageForm.handleBlur}
            helperText={PageForm.errors.slug && PageForm.touched.slug && PageForm.errors.slug}
            error={PageForm.errors.slug && PageForm.touched.slug !== undefined}
          />
        </FormControl>
      </div>

      <div className={classes.BasicInfoRow}>
        <InputLabel id="Page.Content"> {<FormattedMessage id='Fields.label.PageContent'/>} </InputLabel>
        <FormControl variant="outlined">
          <LanguageConsumer>
            {({ locale }) => (
              <div className={classes.PageCKContent + errorClass}>
                <CKEditor
                  placeholder={intl.formatMessage({ id: 'Page.placeholder.PageContent' })}
                  // editor={ClassicEditor}
                  required
                  fullWidth
                  name='content'
                  variant="outlined"
                  data={PageForm.values.content}
                  config={{
                    //   toolbar: ['heading', '|', 'bold', 'italic', 'link', 'numberedList', 'bulletedList', '|', 'indent', 'outdent', '|', 'blockQuote', 'insertTable',
                    //     'mediaEmbed', '|', 'undo', 'redo'],
                    removeButtons: 'About',
                    language: locale
                  }}
                  onChange={(event, editor) => {
                    // PageForm.setFieldValue('content', editor.getData() ? editor.getData() : '' || '')
                    PageForm.setFieldValue('content', event.editor.getData() ? event.editor.getData() : '' || '')
                  }}
                  onOpen={PageForm.handleBlur}
                  helperText={PageForm.errors.content && PageForm.touched.content && PageForm.errors.content}
                  error={PageForm.errors.content && PageForm.touched.content !== undefined}
                />
                {PageForm.errors.content &&
                <FormHelperText error required>{PageForm.errors.content}</FormHelperText>
                }
              </div>
            )}
          </LanguageConsumer>
        </FormControl>
      </div>
      <div className={classes.BasicInfoRow}>
        <InputLabel id="BasicInfo.published"><FormattedMessage
          id='Pages.List.Table.published'/>:</InputLabel>
        <FormControl variant="outlined" className={classes.SwitchWrapper}>
          <FormControlLabel
            label={publishedValue ? intl.formatMessage({ id: 'Pages.List.Table.Published.Option.Published' }) : intl.formatMessage({ id: 'Pages.List.Table.Published.Option.NotPublished' })}
            value={publishedValue ? true : false}
            control={
              <Switch color="primary" checked={publishedValue} value={publishedValue ? true : false}/>
            }
            onChange={handlePublishedChange}
          />
        </FormControl>
      </div>
      <div className={classes.SubmitRow}>
        <button type="submit" disabled={PageForm.isSubmitting || !PageForm.isValid}
                className={classes.AddAdminSubmit}>
          <FormattedMessage id='AdditionalInfo.button.submit'/>
        </button>
        <Button onClick={() => history.push(NamedRoutes[adminSectionType].page.list)} color="primary">
          <FormattedMessage id='ChangePhone.DialogActions.cancel'/>
        </Button>
      </div>
      {PageForm.isSubmitting && <FormLoader loading={true}/>}
    </form>
  )
}

export default PageForm
